import { useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import "./Eula.css"
import AOS from "aos";
import "aos/dist/aos.css";

const Eula = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            <section className="eula-hero">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="content-container">
                    <div className="hero-content">
                        <div className="identifier-mini" data-aos="fade-down">
                            <i className="fa-regular fa-file-contract"></i> ASK JEEVES IP · O'HANLON PATENT INNOVATION
                        </div>
                        <h1 className="hero-title" data-aos="fade-up">End User License Agreement</h1>
                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">The official terms governing the use of our proprietary AI + O'Hanlon legal framework</p>
                    </div>
                </div>
            </section>
            <div className="content-container">
                <div className="eula-card" data-aos="fade-up">

                    <p
                        style={{
                            fontSize: "1.2rem",
                            borderLeft: "4px solid #54A6E9",
                            paddingLeft: "1.5rem"
                        }}
                    >
                        <i
                            className="fa-regular fa-calendar-circle-check"
                            style={{ color: "#1D3A90" }}
                        ></i>{" "}
                        <strong>Last updated:</strong> March 1, 2026
                    </p>

                    <p>
                        <strong>
                            PLEASE READ THIS END USER LICENSE AGREEMENT CAREFULLY BEFORE USING THE
                            ASK JEEVES IP PLATFORM.
                        </strong>{" "}
                        By accessing or using the services, you agree to be bound by this EULA.
                        If you do not agree, you may not use the platform.
                    </p>

                    <h2>
                        <i className="fa-regular fa-key"></i> 1. License Grant
                    </h2>
                    <p>
                        Ask Jeeves IP ("Licensor") grants you a non-exclusive, non-transferable,
                        revocable license to use the proprietary O’Hanlon-enhanced AI patent
                        drafting tools and related materials (the "Software") solely for your
                        internal business purposes or personal innovation, in accordance with the
                        documentation. This license is for the duration of your subscription or
                        free trial.
                    </p>

                    <h2>
                        <i className="fa-regular fa-ban"></i> 2. Restrictions
                    </h2>

                    <p>You shall not (and shall not allow any third party to):</p>

                    <ul>
                        <li>copy, modify, adapt, or create derivative works of the Software;</li>
                        <li>
                            reverse engineer, decompile, or disassemble any portion of the Software,
                            including any O’Hanlon proprietary algorithms;
                        </li>
                        <li>
                            rent, lease, distribute, sublicense, or otherwise transfer rights to the
                            Software;
                        </li>
                        <li>
                            use the Software in any manner that infringes intellectual property or
                            violates applicable laws;
                        </li>
                        <li>access or use the Software to build a competitive service.</li>
                    </ul>

                    <h2>
                        <i className="fa-regular fa-registered"></i> 3. Intellectual Property
                        Rights
                    </h2>

                    <p>
                        The Software, including all O’Hanlon-patented methodologies, user
                        interface, text, and graphics, is owned by Ask Jeeves IP and its licensors
                        and is protected by U.S. and international patent, copyright, and trade
                        secret laws. The O’Hanlon framework and associated patents are proprietary
                        and no ownership is transferred to you.
                    </p>

                    <div className="legal-emphasis" data-aos="zoom-in">
                        <i className="fa-regular fa-registered"></i>{" "}
                        <strong>O’Hanlon Patented Framework:</strong> Portions of the Software are
                        covered by issued and pending patents. Unauthorized use, replication, or
                        reverse engineering is strictly prohibited and may result in legal action.
                    </div>

                    <h2>
                        <i className="fa-regular fa-database"></i> 4. User Data and Drafts
                    </h2>

                    <p>
                        You retain all rights to your invention disclosures, drafts, and documents
                        you create using the Software. By submitting content, you grant Ask Jeeves
                        IP a limited license to host, process, and analyze such content solely to
                        provide and improve the Services, consistent with our Privacy Policy.
                    </p>

                    <h2>
                        <i className="fa-regular fa-credit-card"></i> 5. Subscription and Fees
                    </h2>

                    <p>
                        Certain features require a paid subscription. Fees are non-refundable
                        except as required by law. We may change fees with 30 days’ notice. Unpaid
                        accounts may be suspended or terminated.
                    </p>

                    <h2>
                        <i className="fa-regular fa-circle-stop"></i> 6. Termination
                    </h2>

                    <p>
                        This license continues until terminated. You may terminate by ceasing use
                        and deleting your account. We may terminate or suspend your access
                        immediately if you breach any provision, with or without notice. Upon
                        termination, your right to use the Software ceases.
                    </p>

                    <h2>
                        <i className="fa-regular fa-circle-exclamation"></i> 7. Disclaimer of
                        Warranties
                    </h2>

                    <p>
                        <strong>
                            THE SOFTWARE IS PROVIDED "AS IS" AND "AS AVAILABLE."
                        </strong>{" "}
                        ASK JEEVES IP DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING
                        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                        NO ADVICE OR INFORMATION OBTAINED FROM US SHALL CREATE ANY WARRANTY. WE DO
                        NOT GUARANTEE THAT PATENTS DRAFTED WITH OUR TOOL WILL BE GRANTED.
                    </p>

                    <h2>
                        <i className="fa-regular fa-scale-balanced"></i> 8. Limitation of Liability
                    </h2>

                    <p>
                        TO THE MAXIMUM EXTENT PERMITTED BY LAW, ASK JEEVES IP SHALL NOT BE LIABLE
                        FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
                        OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR
                        INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE
                        LOSSES.
                    </p>

                    <h2>
                        <i className="fa-regular fa-shield"></i> 9. Indemnification
                    </h2>

                    <p>
                        You agree to defend, indemnify, and hold harmless Ask Jeeves IP, its
                        affiliates, and licensors from any claims, damages, liabilities, costs, or
                        expenses (including reasonable attorneys’ fees).
                    </p>

                    <h2>
                        <i className="fa-regular fa-gavel"></i> 10. Governing Law and Dispute
                        Resolution
                    </h2>

                    <p>
                        This EULA shall be governed by the laws of the State of Delaware, without
                        regard to its conflict of laws provisions.
                    </p>

                    <h2>
                        <i className="fa-regular fa-globe"></i> 11. Export Compliance
                    </h2>

                    <p>
                        You may not use, export, or re-export the Software in violation of U.S.
                        export administration regulations or other applicable laws.
                    </p>

                    <h2>
                        <i className="fa-regular fa-file-lines"></i> 12. General Provisions
                    </h2>

                    <p>
                        This EULA constitutes the entire agreement between you and Ask Jeeves IP
                        regarding the Software.
                    </p>

                    <hr
                        style={{
                            margin: "3rem 0",
                            border: "1px solid #e5ecf5"
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "2rem",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <div>
                            <i
                                className="fa-regular fa-envelope"
                                style={{ color: "#1D3A90", marginRight: "8px" }}
                            ></i>{" "}
                            <strong>legal@askjeevesip.tech</strong> (O’Hanlon IP division)
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Eula;